export default __webpack_public_path__ + "static/media/Planilla-completa-de-Cronicidad-form-27-2022.fc8407ef.pdf";